<template>
  <div>
    <base-dialog
      :visible.sync="visible"
      :show-close="true"
      width="calc(100vw - 216px)"
      height="calc(100vh - 100px)"
      class="history-version-dialog"
      border-radius="none"
    >
      <template v-slot:header>
        <div class="header-wrap">
          <div class="title">历史版本</div>
        </div>
      </template>
      <div class="main-wrap">
        <div v-if="!showTable" v-loading="!showTable" class="empty"></div>
        <template v-else>
          <div class="search-wrap">
            <el-input
              v-model="searchText"
              size="small"
              placeholder="搜索版本号"
              clearable
              @keyup.native.enter="search"
              @clear="search"
            >
              <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
            </el-input>
          </div>
          <base-table
            ref="baseTable"
            :data="filterFiles"
            class="history-list-table"
            :border="false"
            :showPagination="false"
          >
            <el-table-column
              v-for="item in milestoneHistoryTableColumns"
              :key="item.value"
              :label="item.label"
              :prop="item.value"
              :column-key="item.value"
            >
              <template slot-scope="scope">
                <div v-if="item.value === 'status'" class="status">已发布</div>
                <div v-else v-tip>{{ _.get(scope.row, item.value) || "" }}</div>
              </template>
            </el-table-column>
            <el-table-column label="操作" min-width="60">
              <template v-slot="scope">
                <base-button @click="toLook(scope.row)" type="text" size="mini">
                  查看
                </base-button>
                <base-button @click="toExport(scope.row)" type="text" size="mini">
                  导出
                </base-button>
              </template>
            </el-table-column>
          </base-table>
        </template>
      </div>
    </base-dialog>
    <VersionDetailDialog ref="versionDetailDialog" :versionId="versionId"></VersionDetailDialog>
  </div>
</template>

<script>
import BaseDialog from "@/components/UIComponents/BaseDialog.vue"
import BaseButton from "@/components/UIComponents/Button.vue"
import BaseTable from "@/components/UIComponents/BaseTable.vue"
import {
  milestoneHistoryTableColumns,
  milestoneTableColumns
} from "@/views/Front/Project/Milestone/static"
import { getMilestoneDetail, getMilestoneHistory } from "@/api/project/project"
import _ from "lodash"
import VersionDetailDialog from "@/views/Front/Project/Milestone/components/versionDetailDialog.vue"
import { exportExcel } from "@/views/Backend/Admin/Layout/mixin/export2Excel"

export default {
  name: "history-version-dialog",
  components: { VersionDetailDialog, BaseButton, BaseTable, BaseDialog },
  props: {
    projectId: String
  },
  data() {
    return {
      milestoneHistoryTableColumns,
      showTable: true,
      fileList: [],
      filterFiles: [],
      searchText: "",
      visible: false,
      fileId: "",
      versionId: ""
    }
  },
  methods: {
    async open() {
      this.fileList = await getMilestoneHistory(this.projectId)
      this.filterFiles = _.cloneDeep(this.fileList)
      this.searchText = ""
      this.visible = true
    },
    search() {
      this.filterFiles = this.fileList.filter(file => file.versionCode.includes(this.searchText))
    },
    async toExport(row) {
      let th = milestoneTableColumns.map(column => column.label)
      let m_data = await getMilestoneDetail(row.id)
      let tData = m_data.map(milestone => {
        let m_key = milestoneTableColumns.map(column => column.prop)
        let m_list = []
        m_key.forEach(k => m_list.push(milestone[k]))
        return m_list
      })
      let tTitle = "[里程碑版本] " + row.versionCode
      exportExcel(th, tData, tTitle)
    },
    toLook(row) {
      this.$refs.versionDetailDialog.open(row)
    }
  }
}
</script>

<style lang="scss" scoped>
.history-version-dialog {
  .status {
    width: 60px;
    padding: 2px 8px;
    background: #1989fa;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 400;
    color: #ffffff;
    line-height: 20px;
  }

  .main-wrap {
    display: flex;
    flex-direction: column;

    .search-wrap {
      display: flex;
      justify-content: space-between;

      .el-input {
        width: 280px;
      }

      ::v-deep {
        .el-input-group__append {
          padding: 0 10px;
        }
      }
    }

    .history-list-table,
    .empty {
      width: 100%;
      margin-top: 13px;
      border: 0.8px solid #dcdfe6;
      border-bottom: none;
      min-height: calc(100% - 58px);
    }

    .base-table {
      flex: 1 1;
      overflow: hidden;
    }

    .operation {
      i {
        cursor: pointer;

        & + i {
          margin-left: 4px;
        }

        &:hover {
          color: $color-main;
        }
      }
    }
  }
}
</style>
